<template>
  <div>
    <div
      v-if="showLoading"
      class="container"
    >
      <van-loading color="#FFD000" />
    </div>
    <div
      v-show="showFaceVerification"
      id="root"
      class="root"
    ></div>
  </div>
</template>

<script>
import KNB from '@dp/knb';
import Dialog from 'vant/lib/dialog';
import { mapGetters, mapState } from 'vuex';
import BillApi from '@/api/bill';
import WalletApi from '@/api/wallet';
import STATUS from '@/constants/status';
import tracker from '@/util/tracker';
import { BID } from '@/constants/statistics';
import { openPage } from '@/util/knb';
import config from '@/config';
import { stringToUUID } from '@/util/uuid';

export default {
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      count: 0,
      timeoutId: -1,
      walletInfo: {},
      requestCode: '',
      appVersion: '',
      showLoading: false,
      showFaceVerification: false,
      signInfo: {},
    };
  },
  computed: {
    ...mapState(['accountType']),
    ...mapState('billModule', ['customerId', 'settleUnitIdList']),
    ...mapGetters(['poiForWallet']),
    cid() {
      return this.$CID.Home;
    },
  },
  watch: {
    value(v) {
      if (v) {
        this.getUndepositBillCount();
      }
    },
  },
  mounted() {
    const el = document.createElement('script');
    el.type = 'text/javascript';
    el.src = `https://s1.meituan.net/mxx/yoda/yoda.seed.js?t=${Date.now()}`;
    document.head.appendChild(el);
    if (!this.$isWXApplet) this.getAppVersion();
  },
  beforeDestroy() {
    clearTimeout(this.timeoutId);
  },
  methods: {
    async getUndepositBillCount() {
      const { customerId, accountType, settleUnitIdList } = this;
      const { code, data, message } = await BillApi.getUndepositBillCount({ customerId, accountType, settleUnitIdList });
      if (code === STATUS.SUCCESS) {
        const count = data.count || 0;
        if (count > 0) {
          Dialog.confirm({
            message: `您有${count}笔账单未入账，是否确认并提现？`,
            confirmButtonText: '确认并提现',
            confirmButtonColor: '#FF8800',
          }).then(() => {
            // this.deposit();
            // 在提现之前需要进行【签约】&【人脸识别】
            this.signAndFace();
            tracker.sendModuleClick(BID.HOME_DEPOSIT_OK, this.cid);
          }).catch(() => {
            this.$emit('input', false);
            tracker.sendModuleClick(BID.HOME_DEPOSIT_CANCEL, this.cid);
          });
        } else {
          // this.deposit();
          // 在提现之前需要进行【签约】&【人脸识别】
          this.signAndFace();
        }
      } else {
        this.$dialog.toast(message || '获取入账信息失败');
      }
    },
    async signAndFace() {
      const { code, data, message } = await BillApi.getSignAndFace();
      if (code === STATUS.SUCCESS && data) {
        this.signInfo = data;
        this.handleSignAndVerification();
      } else {
        this.$dialog.toast(message || '查询签约、人脸识别信息失败');
      }
    },
    handleSignAndVerification(data = {}) {
      const {
        needSign, needVerification, signed, verified, needCollect, collected, needChangeWallet,
      } = { ...this.signInfo, ...data };
      // 签约判定逻辑 https://km.sankuai.com/collabpage/2746809997
      if (needSign && !signed) { // 签约
        this.sign();
      } else if (needSign && signed && needVerification && !verified) { // 人脸识别
        this.face();
      } else if (needCollect && !collected) { // 收集海外人士信息 PS:海外人事不需要人脸识别
        this.handleForeignInfoCollection();
      } else if (needChangeWallet) { // 提示更换钱包信息
        this.handleWalletQualificationError();
      } else {
        this.deposit();
      }
    },
    handleWalletQualificationError() {
      Dialog.alert({
        title: '资质要求提示',
        message: '您好！为了给您带来更好的合作体验，更高效的结算款发放以及个税代扣代缴方案，目前仅支持"中华人民共和国居民身份证"，"港澳居民来往内地通行证"或者"台湾居民来往大陆通行证"或者"外国护照"四种认证方式，还请您更换证件类型进行提现，谢谢！',
        confirmButtonText: '我知道了',
        showCancelButton: false,
      }).then(() => {
        this.$emit('input', false);
      });
    },

    handleForeignInfoCollection() {
      if (this.$router.history?.current?.name === 'ServiceAgreement') {
        this.$router.replace('/settlement-tob/foreign-info-collection');
      } else {
        this.$router.push('/settlement-tob/foreign-info-collection');
      }
      this.$emit('input', false);
    },

    sign() {
      // 跳转签约页面
      this.$router.push({ name: 'ServiceAgreement', params: { signInfo: this.signInfo } });
    },
    getAppVersion() {
      KNB.getAppInfo({
        success: (data) => {
          this.appVersion = data && data.version;
        },
      });
    },
    getUUID() {
      return new Promise((resolve) => {
        let isResolved = false;
        const timeout = setTimeout(() => {
          if (!isResolved) {
            isResolved = true;
            resolve('');
          }
        }, 2000);
        window.LXAnalytics('get', 'uuid', (data) => {
          if (!isResolved) {
            isResolved = true;
            clearTimeout(timeout);
            resolve(data);
          }
        });
      });
    },
    async face() {
      // 跳转人脸识别页面
      let uuid = '';
      uuid = await this.getUUID();
      if (!uuid || uuid.length < 30) {
        uuid = stringToUUID(uuid || Math.random().toString(36).slice(2));
      }
      let params = {};
      if (this.$isWXApplet) {
        params = {
          uuid,
          platform: 13, // 13-小程序端
          app: 439, // 439-美团充电宝商家端
        };
      } else {
        params = {
          uuid,
          platform: /android/i.test(navigator.userAgent) ? 4 : 5, // 5 iPhone 4 安卓
          version: this.appVersion || '1.0.0',
          app: 5, // 5 开店宝
        };
      }
      const { code, data, message } = await BillApi.signAndFaceVerification(params);
      if (code === STATUS.SUCCESS && data) {
        const { needVerification, requestCode } = data;
        if (needVerification) {
          this.jumpToFace(requestCode);
        } else {
          this.deposit();
        }
        this.requestCode = data.requestCode;
      } else {
        this.$emit('input', false);
        this.$dialog.toast(message || '查询授权码失败');
      }
    },
    jumpToFace(requestCode) {
      this.showFaceVerification = true; // 显示全屏
      const options = {
        requestCode, // 必须 授权码，由业务后端下发
        // 必须 回调函数 or 成功回调函数名（函数挂window对象）
        succCallbackFun: 'scf',
        // 必须 回调函数 or 失败回调函数名（函数挂window对象）
        failCallbackFun: 'fcf',
        root: 'root', // 必须 挂载验证方式的节点id，调用前需要确保dom存在，yoda会替换整个dom。
      };
      const envMap = {
        dev: 'test',
        test: 'test',
        staging: 'staging',
        production: '',
      };
      // window.YodaSeed(options); // 线上调用
      window.YodaSeed(options, envMap[config.env]); // 线下环境test、预生产环境staging、不填或其余值均为prod环境
      window.scf = (res) => {
        this.showFaceVerification = false; // 隐藏全屏
        this.$emit('input', false);
        this.queryFaceVerificationResult(res);
      };
      window.fcf = () => {
        this.showFaceVerification = false; // 隐藏全屏
        this.$emit('input', false);
        this.$dialog.toast('人脸识别失败，请重试');
      };
    },
    async queryFaceVerificationResult(res) {
      const { requestCode, responseCode } = res;
      const { code, data, message } = await BillApi.queryFaceVerificationResult({ requestCode, responsCode: responseCode });
      if (code === STATUS.SUCCESS && data) {
        const { result } = data;
        if (result === 1) {
          this.deposit();
        } else {
          this.$dialog.toast('人脸识别失败，请重试');
        }
      } else {
        this.$dialog.toast(message || '查询人脸识别结果失败');
      }
    },
    async deposit() {
      this.showLoading = true;
      const { customerId, accountType, settleUnitIdList } = this;
      const { code, data, message } = await BillApi.deposit({ customerId, accountType, settleUnitIdList });
      if (code === STATUS.SUCCESS) {
        this.getHomePageUrl(data === 0);
      } else {
        this.showLoading = false;
        this.$dialog.toast(message || '提现失败');
      }
    },
    async getHomePageUrl(jump) {
      const { code, data, message } = await WalletApi.getHomePageUrl(this.poiForWallet);
      if (code === STATUS.SUCCESS) {
        this.walletInfo = data;
        if (jump) {
          this.jumpToHomePage();
        } else {
          this.count = 0;
          this.timeoutId = setTimeout(() => {
            this.getAbleJumpToWallet();
          }, this.walletInfo.delayTime * 1000);
        }
      } else {
        this.$dialog.toast(message || '获取钱包地址失败');
      }
    },
    async getAbleJumpToWallet() {
      const { customerId, accountType, settleUnitIdList } = this;
      const { code, data } = await BillApi.getAbleJumpToWallet({ customerId, accountType, settleUnitIdList });
      if (code === STATUS.SUCCESS && data) {
        this.jumpToHomePage();
      } else {
        this.count = this.count + 1;
        if (this.count >= this.walletInfo.count) {
          this.jumpToHomePage();
        } else {
          this.timeoutId = setTimeout(() => {
            this.getAbleJumpToWallet();
          }, this.walletInfo.intervalTime * 1000);
        }
      }
    },
    jumpToHomePage() {
      this.showLoading = false;
      clearTimeout(this.timeoutId);
      this.$emit('input', false);
      openPage(this.walletInfo.url);
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  position:absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0,0,0,0.4);
}
.root {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1000;
}
</style>
